"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const VideoHint = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onClick = () => {
        navigate(-1);
        // @ts-ignore
        window.imagePickerDelegate.showStickyImagePicker();
    };
    return ((0, jsx_runtime_1.jsx)(FullScreenDiv, { "data-e2e": 'FullScreenDiv', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'Title', children: (0, i18n_1.Localized)(i18n_1.Strings.stickyVideo.title) }), (0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'Text', children: (0, i18n_1.Localized)(i18n_1.Strings.stickyVideo.text) }), (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: onClick, "data-e2e": 'StyledPrimaryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.stickyVideo.buttonText) })] }) }));
};
const FullScreenDiv = styled_components_1.default.div `
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.tabs.panel.containerShadowColor};
  z-index: 1;
`;
const Container = styled_components_1.default.div `
  max-width: 40em;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: auto;
  padding: 30px;
`;
const Title = styled_components_1.default.h1 `
  max-width: 50em;
  font-size: 2em;
  padding: 0;
  font-weight: normal;
  color: ${({ theme }) => theme.text};
`;
const Text = styled_components_1.default.p `
  max-width: 50em;
  margin: 0 0 40px 0;
  font-size: 1.6em;
  color: ${props => props.theme.white};
`;
const StyledPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  margin: 0 auto;
  width: 138px;
  height: 38px;
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 1.4em;
  padding: 10px 15px;
`;
exports.default = VideoHint;
